const header = document.querySelector(".header");

if (header) {
  const selectors = {
    subMenus: document.querySelectorAll(".header__li--mega-menu"),
  };

  selectors.subMenus.forEach((subMenu) => {
    const targetMenu = subMenu.querySelector(".header__li--sub-menu-title");
    const childrenMenu = subMenu.querySelector(".header__submenu");

    if (targetMenu && childrenMenu) {
      targetMenu.addEventListener("click", (e) => {
        e.preventDefault();

        const isAlreadyOpen = targetMenu.classList.contains("active");

        selectors.subMenus.forEach((menu) => {
          const otherTitle = menu.querySelector(".header__li--sub-menu-title");
          const otherSubmenu = menu.querySelector(".header__submenu");

          if (otherTitle && otherSubmenu) {
            otherTitle.classList.remove("active");
            otherSubmenu.classList.remove("isOpen");
          }
        });

        if (!isAlreadyOpen) {
          targetMenu.classList.add("active");
          childrenMenu.classList.add("isOpen");
        }
      });
    }
  });
}
